
export class QrCodeApiModel {
    constructor(
        public qrCode: string = '',
        public cnpj: string = '',
        public terminal: string = '',
        public usuario: string = ''
    ) { }
}